export default __webpack_public_path__ + "resources/icons/n312-b6e5.png";